const gradientBlueAndPurple = 'linear-gradient(265.6deg, #F0E1FF 24.3%, #D3EFEE 75.95%)';

export default gradientBlueAndPurple;
